/** Coloured chalk used across the UI. Class strings are literal so Tailwind can see them. */
export type Chalk = 'yellow' | 'pink' | 'blue' | 'green' | 'orange' | 'lilac';

export const CHALK: Record<Chalk, { text: string; bg: string; soft: string; border: string; stroke: string }> = {
  yellow: {
    text: 'text-chalk-yellow',
    bg: 'bg-chalk-yellow',
    soft: 'bg-chalk-yellow/15',
    border: 'border-chalk-yellow/40',
    stroke: 'rgb(var(--chalk-yellow))',
  },
  pink: {
    text: 'text-chalk-pink',
    bg: 'bg-chalk-pink',
    soft: 'bg-chalk-pink/15',
    border: 'border-chalk-pink/40',
    stroke: 'rgb(var(--chalk-pink))',
  },
  blue: {
    text: 'text-chalk-blue',
    bg: 'bg-chalk-blue',
    soft: 'bg-chalk-blue/15',
    border: 'border-chalk-blue/40',
    stroke: 'rgb(var(--chalk-blue))',
  },
  green: {
    text: 'text-chalk-green',
    bg: 'bg-chalk-green',
    soft: 'bg-chalk-green/15',
    border: 'border-chalk-green/40',
    stroke: 'rgb(var(--chalk-green))',
  },
  orange: {
    text: 'text-chalk-orange',
    bg: 'bg-chalk-orange',
    soft: 'bg-chalk-orange/15',
    border: 'border-chalk-orange/40',
    stroke: 'rgb(var(--chalk-orange))',
  },
  lilac: {
    text: 'text-chalk-lilac',
    bg: 'bg-chalk-lilac',
    soft: 'bg-chalk-lilac/15',
    border: 'border-chalk-lilac/40',
    stroke: 'rgb(var(--chalk-lilac))',
  },
};
